import { BundleDescriptionIcons } from "./BundleDescriptionIcons";
import { BundleDescriptionLinks } from "./BundleDescriptionLinks";
import { RetiredStaticBundleComponentParent } from "@/types/types";
import { getDescription } from "@/utils/product/getDescription";
import styles from "./BundleProductDescription.module.scss";

type Props = {
  product: RetiredStaticBundleComponentParent;
};

export const BundleProductDescription = ({ product }: Props) => {
  const description = getDescription(product);
  const displayCode = product.defaultVariant.displayCode;

  return (
    <div className={styles.descriptionContainer}>
      <p data-testid="bundleProductDescription:code">
        <strong>Product code: {displayCode}</strong>
      </p>
      <BundleDescriptionIcons product={product} />
      <div
        data-testid="bundleProductDescription:content"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
      <BundleDescriptionLinks product={product} />
    </div>
  );
};
